export const USER_LOAD_SUCCESS = 'USER_LOAD_SUCCESS'
export const USER_SELECT_MUNICIPALITY = 'USER_SELECT_MUNICIPALITY'
export const USER_UPDATE = 'USER_UPDATE'
